const FileUpload = process.env.REACT_APP_FILE_UPLOAD_URL || "http://localhost:8000/media/";

export default FileUpload;
